module.exports = __webpack_public_path__ + "static/media/arrow-up-solid.25a9000e.svg";